import React, { useEffect, useState } from "react";
import AdminCareerTable from "./AdminTables/CareerTable";
import CareerForm, { CareerFormValues } from "../Forms/CareerForm";
// import { CareerFormValues } from "../types/CareerFormValues";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from "@mui/material";
import {  CareerFormData, createCareer, updateCareer } from "../services/careerService";
import { toast } from "react-toastify";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ManageCareer = () => {
  const [editingCareer, setEditingCareer] = useState<(CareerFormValues & { id: string }) | null>(null);
  const [expanded, setExpanded] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState(false);

  const handleCreate = async (values: CareerFormValues) => {
    try {
      const payload = structuredClone(values);
      delete payload.id; // remove id if present
      await createCareer(payload);
      toast.success("Career created");
      setEditingCareer(null); // reset form
    } catch (err) {
      toast.error("Failed to create career");
    }
  };

  const handleUpdate = async (values: CareerFormData) => {
    try {
      await updateCareer(values.id, values);
      toast.success("Career updated");
      setEditingCareer(null);
    } catch (err) {
      toast.error("Failed to update career");
    }
  };

  const resetDefaultValues = () => {
    setEditingCareer({
      id: "",
      noticePeriod: "",
      education: "",
      experienceLevel: "",
      maxExperienceLevel:'',
      extraFields: [],
      industry: '',
      salary: "",
      generalDescription: "",
      jobDescription: "",
      jobTitle: "",
      jobType: "",
      jobLocation: "",
      benefits: [], 
    })
  };

  
  useEffect(() => {
    if(isEdit) {
       
      setExpanded(true);
    }
  }, [isEdit]);

  return (
    <Box p={3}>
      <Accordion expanded={expanded}  >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
        onClick={() => {
          setExpanded(!expanded);
          setIsEdit(false); 
          resetDefaultValues()}}>
            <Typography variant="h5">Manage Careers</Typography>
        </AccordionSummary>
          <AccordionDetails>

          
      <Typography variant="h4" gutterBottom>
        Manage Careers
      </Typography>

      <Box mb={4}>
        <CareerForm
          defaultValues={editingCareer || undefined}
          onSubmit={isEdit ? handleUpdate : handleCreate}
          onCancel={() => setEditingCareer(null)}
        />
      </Box>
      </AccordionDetails>
      </Accordion>

      <AdminCareerTable onEdit={(career:CareerFormData) => {setEditingCareer(career); setIsEdit(true)}} />
    </Box>
  );
};

export default ManageCareer;
